/* MonKoku Maison · Duft-Vergleich: bis zu drei Düfte nebeneinander */
(function () {
  'use strict';
  var M = window.MKS;
  if (!M || window.MKC) return;
  window.MKC = {};
  var esc = M.esc, money = M.money, by = null, bar = null, dlg = null, toastT = 0;

  function ensure() {
    if (by) return Promise.resolve(by);
    return M.load().then(function (all) { by = {}; all.forEach(function (x) { by[x.h] = x; }); return by; });
  }

  function syncBtns() {
    var list = M.cmp.get();
    Array.prototype.forEach.call(document.querySelectorAll('[data-mk-cmp]'), function (b) {
      var on = list.indexOf(b.getAttribute('data-mk-cmp')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var l = b.querySelector('[data-l]');
      if (l) l.textContent = on ? 'Im Vergleich' : 'Vergleichen';
    });
  }
  window.MKC.sync = syncBtns;

  function toast(t) {
    var el = document.querySelector('.mkc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'mkc-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = t; el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 3800);
  }

  /* Leiste unten */
  function renderBar() {
    var list = M.cmp.get();
    if (!list.length) { if (bar) bar.hidden = true; return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mkc-bar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Duft-Vergleich');
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-mkc-rm],[data-mkc-open],[data-mkc-clear]') : null;
        if (!t) return;
        if (t.hasAttribute('data-mkc-rm')) M.cmp.toggle(t.getAttribute('data-mkc-rm'));
        else if (t.hasAttribute('data-mkc-clear')) M.cmp.set([]);
        else if (!t.disabled) openDlg();
      });
    }
    bar.hidden = false;
    ensure().then(function (d) {
      var l = M.cmp.get(), items = l.map(function (h) { return d[h]; }).filter(Boolean);
      if (!items.length) { bar.hidden = true; return; }
      bar.innerHTML = '<ul class="mkc-bar__th">' + items.map(function (x) {
        return '<li><button type="button" class="mkc-th" data-mkc-rm="' + esc(x.h) + '" aria-label="' + esc(x.t) + ' aus dem Vergleich entfernen">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="96" height="96" decoding="async">' : '') + '<span class="mkc-th__x" aria-hidden="true">×</span></button></li>';
      }).join('') + '</ul><div class="mkc-bar__m"><p class="mkc-bar__t">' + items.length + ' von ' + M.cmp.max + ' im Vergleich</p><p class="mkc-bar__s">' + (items.length < 2 ? 'Wähle noch einen Duft dazu.' : 'Bereit zum Vergleichen.') + '</p></div>' +
        '<button type="button" class="mkc-go" data-mkc-open' + (items.length < 2 ? ' disabled' : '') + '>Vergleichen</button>' +
        '<button type="button" class="mkc-clr" data-mkc-clear aria-label="Vergleich leeren">Leeren</button>';
    }).catch(function () { bar.hidden = true; });
  }

  /* Vergleichsfenster */
  function chips(arr, shared) {
    if (!arr || !arr.length) return '<span class="mkc-none">–</span>';
    return '<ul class="mkc-chips">' + arr.map(function (n) {
      return '<li' + (shared && shared[M.norm(n)] ? ' class="is-shared"' : '') + '>' + esc(n) + '</li>';
    }).join('') + '</ul>';
  }
  function perMl(v, ml) { return v ? money(v[1] / ml) + ' pro ml' : ''; }
  function table(items) {
    var N = items.length, cnt = {}, shared = {};
    items.forEach(function (x) {
      var seen = {};
      x.n.forEach(function (n) { var k = M.norm(n); if (!seen[k]) { seen[k] = 1; cnt[k] = (cnt[k] || 0) + 1; } });
    });
    Object.keys(cnt).forEach(function (k) { if (cnt[k] > 1) shared[k] = 1; });
    var hasTier = items.some(function (x) { return (x.nk && x.nk.length) || (x.nh && x.nh.length) || (x.nb && x.nb.length); });
    var hasFlat = items.some(function (x) { return x.nf && x.nf.length; });
    function row(label, fn) {
      return '<div class="mkc-row"><p class="mkc-lab">' + label + '</p><div class="mkc-cells" style="--n:' + N + '">' + items.map(function (x) { return '<div class="mkc-cell">' + fn(x) + '</div>'; }).join('') + '</div></div>';
    }
    var top = '<div class="mkc-row"><div class="mkc-cells" style="--n:' + N + '">' + items.map(function (x) {
      return '<div class="mkc-cell mkc-cell--top"><span class="mkc-img">' + (x.img ? '<img src="' + esc(x.img) + '" alt="' + esc(x.t) + ' Extrait de Parfum" width="480" height="480" loading="lazy" decoding="async">' : '') + '</span>' +
        '<h3 class="mkc-name"><a href="' + esc(x.url) + '">' + esc(x.t) + '</a></h3>' + (x.k ? '<p class="mkc-k">' + esc(x.k) + '</p>' : '') +
        '<button type="button" class="mkc-rm" data-mkc-rm="' + esc(x.h) + '">Entfernen</button></div>';
    }).join('') + '</div></div>';
    var rows = '';
    if (hasTier) {
      rows += row('Kopfnote', function (x) { return chips(x.nk, shared); });
      rows += row('Herznote', function (x) { return chips(x.nh, shared); });
      rows += row('Basisnote', function (x) { return chips(x.nb, shared); });
    }
    if (hasFlat) rows += row('Duftnoten', function (x) { return chips(x.nf, shared); });
    rows += row('Duftrichtung', function (x) { return chips(x.r); });
    rows += row('Jahreszeit', function (x) { return chips(x.s); });
    rows += row('Anlass', function (x) { return chips(x.o); });
    rows += row('Preis', function (x) {
      return '<p class="mkc-price">' + (x.v5 ? '<span><b>5 ml</b> ' + money(x.v5[1]) + '<small>' + perMl(x.v5, 5) + '</small></span>' : '') + (x.v50 ? '<span><b>50 ml</b> ' + money(x.v50[1]) + '<small>' + perMl(x.v50, 50) + '</small></span>' : '') + '</p>';
    });
    var buy = '<div class="mkc-row"><div class="mkc-cells" style="--n:' + N + '">' + items.map(function (x) {
      var av = x.v5 && x.v5[2] === 1;
      return '<div class="mkc-cell"><button type="button" class="mkc-add" data-mkc-add="' + esc(x.h) + '"' + (av ? '' : ' disabled') + '>' + (av ? '5-ml-Probe · ' + money(x.v5[1]) : 'Probe ausverkauft') + '</button><a class="mkc-more" href="' + esc(x.url) + '">Zum Duft</a></div>';
    }).join('') + '</div></div>';
    return '<div class="mkc-panel"><header class="mkc-head"><h2 id="mkc-t">Düfte im Vergleich</h2><button type="button" class="mkc-close" data-mkc-close aria-label="Vergleich schließen">×</button></header>' +
      '<p class="mkc-legend"><i aria-hidden="true"></i> Gemeinsame Noten sind hervorgehoben.</p>' +
      '<div class="mkc-scroll"><div class="mkc-tbl" style="--n:' + N + '">' + top + rows + buy + '</div></div></div>';
  }

  function closeDlg() {
    if (dlg && dlg.open) dlg.close();
    document.documentElement.classList.remove('mkc-open');
  }

  function paintDlg() {
    var list = M.cmp.get(), items = list.map(function (h) { return by[h]; }).filter(Boolean);
    if (items.length < 2) { closeDlg(); return; }
    var sc = dlg.querySelector('.mkc-scroll'), x = sc ? sc.scrollLeft : 0;
    dlg.innerHTML = table(items);
    var nsc = dlg.querySelector('.mkc-scroll');
    if (nsc) nsc.scrollLeft = x;
  }
  function openDlg() {
    if (M.cmp.get().length < 2) return;
    ensure().then(function () {
      if (!dlg) {
        dlg = document.createElement('dialog');
        dlg.className = 'mkc-dlg'; dlg.setAttribute('aria-labelledby', 'mkc-t');
        document.body.appendChild(dlg);
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg) { closeDlg(); return; }
          var t = e.target.closest ? e.target.closest('[data-mkc-close],[data-mkc-rm],[data-mkc-add]') : null;
          if (!t) return;
          if (t.hasAttribute('data-mkc-close')) closeDlg();
          else if (t.hasAttribute('data-mkc-rm')) M.cmp.toggle(t.getAttribute('data-mkc-rm'));
          else if (!t.disabled) {
            var x = by[t.getAttribute('data-mkc-add')];
            if (!x || !x.v5) return;
            closeDlg();
            M.addToCart([{ id: x.v5[0], quantity: 1 }], '').catch(function (er) { toast('Das hat nicht geklappt: ' + (er && er.message ? er.message : 'Bitte versuche es erneut.')); });
          }
        });
        dlg.addEventListener('close', function () { document.documentElement.classList.remove('mkc-open'); });
      }
      paintDlg();
      if (!dlg.open && dlg.showModal) { dlg.showModal(); document.documentElement.classList.add('mkc-open'); }
    }).catch(function () { toast('Der Vergleich konnte gerade nicht geladen werden.'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mk-cmp]') : null;
    if (!b) return;
    e.preventDefault();
    var r = M.cmp.toggle(b.getAttribute('data-mk-cmp'));
    if (r.full) toast('Du kannst bis zu ' + M.cmp.max + ' Düfte vergleichen. Entferne zuerst einen.');
  });
  document.addEventListener('mks:cmp', function () {
    syncBtns(); renderBar();
    if (dlg && dlg.open && by) paintDlg();
  });
  function later() { setTimeout(syncBtns, 80); setTimeout(syncBtns, 600); }
  document.addEventListener('variant:change', later);
  document.addEventListener('product:rerender', later);
  window.addEventListener('pageshow', function () { syncBtns(); renderBar(); });
  function boot() { syncBtns(); renderBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();